/** Display legends for keys that do NOT emit a character, so they don't vary by Keyboard Layout. */
const UNIVERSAL: Record<string, string> = {
  Backspace: "⌫",
  Tab: "Tab",
  CapsLock: "Caps",
  Enter: "Enter",
  ShiftLeft: "Shift",
  ShiftRight: "Shift",
  ControlLeft: "Ctrl",
  ControlRight: "Ctrl",
  MetaLeft: "Win",
  MetaRight: "Win",
  AltLeft: "Alt",
  AltRight: "Alt",
  ContextMenu: "Menu",
  Space: "Space",
  Escape: "Esc",
  ArrowUp: "↑",
  ArrowDown: "↓",
  ArrowLeft: "←",
  ArrowRight: "→",
  Insert: "Ins",
  Home: "Home",
  PageUp: "PgUp",
  Delete: "Del",
  End: "End",
  PageDown: "PgDn",
  PrintScreen: "PrtSc",
  ScrollLock: "ScrLk",
  Pause: "Pause",
  NumLock: "Num",
  NumpadDivide: "/",
  NumpadMultiply: "*",
  NumpadSubtract: "–",
  NumpadAdd: "+",
  NumpadEnter: "Ent",
  NumpadDecimal: ".",
};

/**
 * Fallback legend for a code when the Keyboard Layout supplies no char.
 * Handles fixed non-char keys, plus a code-derived display (KeyA gives A, F5 gives F5, Numpad7 gives 7).
 */
export function legendFor(code: string): string {
  if (UNIVERSAL[code] != null) return UNIVERSAL[code] as string;
  const letter = /^Key([A-Z])$/.exec(code);
  if (letter) return letter[1] as string;
  const digit = /^Digit(\d)$/.exec(code);
  if (digit) return digit[1] as string;
  if (/^F(\d{1,2})$/.test(code)) return code;
  const np = /^Numpad(\d)$/.exec(code);
  if (np) return np[1] as string;
  // unknown / placeholder codes (e.g. imported blank keys) render as a blank cap
  return "";
}
